<template>
  <div class="binItem myinput">
    <div class="title">请选择绑定仪器</div>
    <div class="binItem-list">
      <div class="search">
        <el-input size="small" v-model="search" suffix-icon="el-icon-search" placeholder="请输入仪器名称或者仪器编号检索"></el-input>
      </div>
      <div class="yq-list bar" id="viewBox" ref="viewBox">
        <template v-for="(item,index) in InstrumentList">
          <div class="list-item" :key="index">
            <div class="cheeke">
              <input type="radio" v-model="checkedValue" @change="checkOption" :value="item.id" />
            </div>
            <div class="name">{{ item.instrumentName }}</div>
            <div class="bianhao">{{ item.serialNumber }}</div>
          </div>
        </template>
        <p class="foter" v-if="!noMore">加载中···</p>
        <p class="foter" v-else>暂无更多数据···</p>
      </div>
    </div>
    <div class="footer">
      <div class="my-buttom select-buttom" @click="notarize">确认</div>
      <div class="my-buttom" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
import { getFreeInsList4 } from "@/api/depotApi.js";
import { getFreeInsList } from "@/api/warehouse.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      REQUIRE: true,
      InstrumentList: [],
      checkList: false, //选中的仪器
      checkedValue: "", //选中的checked项
      search: "",
      deptId: "", //单位
      currentPage: 1,
      pageSize: 10,
      total: 0, //总数
      box: "", //元素
    };
  },
  props:{
   type:{
    type:Number,
    default:0
   }
  },
  created() {
    this.deptId = this.$store.state.user.userInfo.deptId;
    this.fetchData();
  },
  mounted() {
    this.box = this.$refs.viewBox;
    //添加滚动事件，检测滚动到页面底部
    this.box.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState(["depot"]),
    noMore() {
      return this.InstrumentList.length >= this.total;
    },
  },
  methods: {
    //获取数据
   async fetchData(val) {
      this.DepotId = sessionStorage.getItem("depotId");
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        deviceType: 3,
        deptId: this.deptId,
        depotId: this.DepotId,
        ...val,
      };
      console.log(23123)
      const  res =  this.type==1? await getFreeInsList(params) : await getFreeInsList4(params)
      let {code,data,msg} = res
      if(code==200){
        this.total = data.total;
        this.InstrumentList = [...this.InstrumentList, ...data.records];
      }
      // getFreeInsList4(params).then((res) => {
      //   this.total = res.data.total;
      //   this.InstrumentList = [...this.InstrumentList, ...res.data.records];
      // });
    },
    //仪器列表选中值
    checkOption(val) {
      // console.log("仪器列表选中仪器ID：", this.checkedValue);
    },
    notarize() {
      if (this.checkedValue) {
        this.$emit("pcheckValue", this.checkedValue);
      } else {
        this.$message.error("请选择仪器后进行绑定");
        return false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    handleScroll() {
      // 滚动到页面底部时
      var scrollTop = this.box.scrollTop;
      var windowHeitht = this.box.clientHeight;
      var scrollHeight = this.box.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht == scrollHeight) {
        if (!this.noMore) {
          this.currentPage++;
          this.fetchData();
        } else {
          return;
        }
      }
    },
  },
  watch: {
    search() {
      delay(() => {
        this.currentPage = 1;
        this.InstrumentList = [];
        this.fetchData({ searchInfo: this.search });
      }, 1000);
    }

  },
};
</script>

<style lang="less" scoped>
.binItem {
  width: 100%;
  height: 426px;
  color: #74c8fe;
  .title {
    text-align: center;
    height: 27px;
    line-height: 27px;
    font-size: 28px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #74c8fe;
  }
  .binItem-list {
    margin: auto;
    margin-top: 20px;
    width: 349px;
    height: 330px;
    .search {
      margin: 10px;
    }
    .yq-list {
      height: 276px;
      border: 2px solid #0288e1;
      border-radius: 4px;
      box-shadow: 0 0 30px #046ab3 inset;
      padding: 4px 10px;
      box-sizing: border-box;
      overflow-y: scroll;
      .list-item {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;

        .cheeke {
          width: 10%;
        }
        .name {
          width: 50%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .bianhao {
          width: 40%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .foter {
        text-align: center;
      }
    }
  }
  .cheeke /deep/ .el-checkbox__inner {
    border: 1px solid #0288e1;
    width: 18px;
    height: 18px;
    background: #083d77;
  }
  .cheeke /deep/ .el-checkbox__inner::after {
    border: 1px solid #0288e1;
    border-left: 0;
    border-top: 0;
    height: 8px;
    left: 6px;
    top: 2px;
  }
  .footer {
    margin: 10px 0;
    text-align: center;
  }
}

input[type="radio"] {
  color: #74b7ff;
}
input[type="radio"]::after {
  background-color: #1e5fb3;
  color: #74b7ff;
}
input[type="radio"]:checked::after {
  background: #1e5fb3;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/instrumentList.vue